export interface INotificationMessage {
  type: ENotificationMessage
  i18nTitle: string
  i18nMessage: string
}

export enum ENotificationMessage {
  INFO = 'INFO',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}
